export default __webpack_public_path__ + "static/media/aarp-sweeps-jg.5ff1cb9f.jpg";